export const RESIZE = 'RESIZE'
export const RESIZED = 'RESIZED'

export const forceResize = () => ({type: RESIZE})
export const resized = () => ({type: RESIZED})
